<template>
  <v-card v-bind="$attrs">
    <v-card-title>
      <section-header icon="mdi mdi-share">
        {{ $t('surveys.share_survey') }}
      </section-header>
    </v-card-title>
    <v-card-text v-if="teams.length === 0" class="body-1">
      {{ $t('surveys.you_need_to_create_team') }}
    </v-card-text>
    <v-card-text v-if="teams.length > 0">
      <div class="mb-4 text-body-2 text-sm-body-1">{{ $t('surveys.share_survey_guide') }}</div>
      <v-slide-x-transition group>
        <template v-for="team in availableTeams">
          <team-share-survey :key="team.key"
                             :get-survey-shares="getSurveyShares"
                             :survey="survey"
                             :surveyShares="surveyShares"
                             :team="team" @open-team="handleOpenTeamEdit"
                             @share-with-email="handleShareWithEmail" @refresh-survey-shares="getSurveyShares"/>

        </template>
      </v-slide-x-transition>
    </v-card-text>
    <v-card-actions v-if="!$isReadOnlyUser"
                    :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : ''">
      <v-btn :block="$vuetify.breakpoint.xsOnly"
             :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
             :outlined="$vuetify.breakpoint.xsOnly"
             color="primary" text @click="handleCreateTeam">
        <v-icon left>add</v-icon>
        {{ $t('teams.create_team') }}
      </v-btn>
    </v-card-actions>

    <edit-team-dialog ref="editTeamDialog"
                      :surveyType="survey.surveyTemplate.type"
                      @refresh="reloadTeams"/>

    <share-with-email-dialog ref="shareDialog"/>

  </v-card>
</template>

<script>
import TeamShareSurvey from "@/components/Tenant/TeamShareSurvey";
import EditTeamDialog from "@/components/Tenant/EditTeamDialog";
import ShareWithEmailDialog from "@/components/Tenant/ShareWithEmailDialog";
import surveyShareApi from "@/api/surveyshare";
import SectionHeader from "@/components/SectionHeader";

export default {
  name: "ShareSurveyCard",
  components: {SectionHeader, ShareWithEmailDialog, EditTeamDialog, TeamShareSurvey},
  props: ['teams', 'survey'],
  data() {
    return {
      surveyShares: [],
    }
  },
  computed: {
    availableTeams() {
      if (this.survey?.surveyTemplate?.type === 'MANAGEMENT') {
        return this.teams.filter(team => team.type === this.survey.surveyTemplate.type)
      } else {
        return this.teams
      }
    }
  },
  methods: {
    async getSurveyShares() {
      this.surveyShares = await surveyShareApi.getSurveyShares(this.survey.key);
    },
    reloadTeams() {
      this.$emit('reload-teams');
    },
    handleShareWithEmail(surveyShare) {
      this.$refs.shareDialog.open(surveyShare);
    },
    handleOpenTeamEdit(team) {
      this.$refs.editTeamDialog.open(team.key);
    },
    handleCreateTeam() {
      this.$refs.editTeamDialog.open();
    },
  },
  mounted() {
    this.getSurveyShares();
  }
}
</script>

<style scoped>

</style>
